import React, { useMemo } from "react";
import { useCareManagementQuery } from "../../../hooks/queries/useCareManagementQuery";
import { useAppSelector } from "../../../store/hooks";
import { buildWorkingDrgSummary } from "../../../utils/caire-working-drg-utils";
import { PredictiveDispositionPanel } from "../PredictiveDisposition";
import CairePollingShell from "../CairePollingShell";

const PredictedDcDisposition: React.FC = () => {
  const mrn = useAppSelector((state) => state.fhir.mrn) ?? "";
  const providerNpi = useAppSelector((state) => state.provider.providerNPI);
  const { data, isLoading, isFetching, isError } = useCareManagementQuery(
    mrn,
    providerNpi,
    { polling: true }
  );

  const workingDrg = useMemo(() => buildWorkingDrgSummary(data), [data]);

  if (isLoading)
    return (
      <p className="p-4 text-sm text-gray-500">
        Loading care management data...
      </p>
    );
  if (isError)
    return (
      <p className="p-4 text-sm text-red-600">
        Unable to load care management data.
      </p>
    );
  if (!data?.review)
    return (
      <p className="p-4 text-sm text-gray-500">
        No care management query is assigned for this patient.
      </p>
    );

  const losMetrics = data.review.utilizationAnalysis?.losMetrics;
  const metrics =
    typeof losMetrics?.gmlos === "number" &&
    typeof losMetrics?.currentLos === "number"
      ? {
          gmlos: losMetrics.gmlos,
          currentLos: losMetrics.currentLos,
          losDrift:
            typeof losMetrics.losDrift === "number"
              ? losMetrics.losDrift
              : losMetrics.currentLos - losMetrics.gmlos,
        }
      : null;

  return (
    <CairePollingShell refreshing={isFetching && !isLoading}>
      <PredictiveDispositionPanel
        options={data.review.options ?? []}
        metrics={metrics}
        workingDrg={workingDrg}
      />
    </CairePollingShell>
  );
};

export default PredictedDcDisposition;
